import { Application } from '@hotwired/stimulus';
import { registerControllers } from '../controllers';

const application = Application.start(document.documentElement);

registerControllers(application);

declare const window: Window & { Stimulus: Application };
window.Stimulus = application;

application.debug = true;

export { application };
